export const isObject = (obj) => {
  return (obj !== null) && (typeof obj === 'object') && (!Array.isArray(obj))
}

export const isEmptyObject = (obj) => {
  return !isObject(obj) || Object.entries(obj).length <= 0
}

export const isNumber = (value) => {
  return typeof value === 'number' || String.call(value) === '[object Number]'
}

export const isString = (value) => {
  return typeof value === 'string' || String.call(value) === '[object String]'
}